import { useState, useEffect } from 'react';
import { fetchPresenterComments } from '../services/presenterCommentsService';

/**
 * Load presenter comments when the panel is open.
 * @param {string|null|undefined} viewId
 * @param {boolean} enabled - Fetch when true (panel open)
 */
export function usePresenterComments(viewId, enabled) {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !viewId) {
      setComments([]);
      setLoading(false);
      setError(null);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);
    setComments([]);

    fetchPresenterComments(viewId)
      .then((data) => {
        if (!cancelled) {
          setComments(Array.isArray(data) ? data : []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(
            err?.response?.data?.error || err?.message || 'Failed to load comments'
          );
          setComments([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [viewId, enabled]);

  return { comments, loading, error };
}
